<script setup lang="ts">
defineProps({
  type: null
})
const { t } = useI18n()
const router = useRouter()
const switchCreator = () => {
  router.push({
    name: 'BecomeCreatorIntro'
  })
}
</script>

<template>
  <DfansButton
    v-if="type === 'default'"
    :text="t('Global.BecomeCreator')"
    type="default"
    class="!text-base h-12 mx-auto w-max !rounded-full px-5"
    @click="switchCreator"
  />
  <DfansButton
    v-else-if="type === 'tabbar'"
    :text="t('Global.BecomeCreator')"
    type="default"
    class="!text-sm h-9 mx-auto w-full mt-3 dark:!text-brand !text-white"
    @click="switchCreator"
  >
    <template #icon>
      <div
        i-material-symbols:account-balance-outline
        class="w-5 h-5 dark:!text-brand !text-white mr-2"
      />
    </template>
  </DfansButton>
  <DfansButton
    v-else
    :text="t('Global.BecomeCreator')"
    type="gray"
    class="!text-sm h-10 mt-3 mx-auto w-full"
    @click="switchCreator"
  >
    <template #icon>
      <div i-material-symbols:account-balance-outline class="w-5 h-5 icon-bg-right mr-2" />
    </template>
  </DfansButton>
</template>

<style lang="less" scoped>
.addFunds:hover > .font-bg {
  display: none;
}

.addFunds:hover > .text-brand {
  display: block;
}
</style>
